import { render, staticRenderFns } from "./advice.vue?vue&type=template&id=23afb95e&scoped=true"
import script from "./advice.vue?vue&type=script&lang=js"
export * from "./advice.vue?vue&type=script&lang=js"
import style0 from "./advice.vue?vue&type=style&index=0&id=23afb95e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23afb95e",
  null
  
)

export default component.exports